<template>
  <owal-banner
    class="owal-spinner-banner__container"
  >
    <owal-spinner-logo
      class="logo-image"
    />
    <div>
      Loading...
    </div>
  </owal-banner>
</template>

<script>
import OwalBanner from '@/libraries/owal-ui/banners/OwalBanner'
import OwalSpinnerLogo from '@/libraries/owal-ui/spinners/OwalSpinnerLogo'

export default {
  name: 'OwalSpinnerBanner',
  components: { OwalBanner, OwalSpinnerLogo },
}
</script>

<style scoped>
.owal-spinner-banner__container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Lato-Bold';
  padding: 0;
  margin: 0;
  width: 200px;
  margin: 0.5714285715rem auto;
}

/** The spinning logo */
.logo-image {
  height: 3rem;
  width: 3rem;
}
</style>
